/* eslint-disable radix */
/* eslint-disable prefer-rest-params */
/* eslint-disable valid-typeof */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable prettier/prettier */
/* eslint-disable function-paren-newline */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */
import jQuery from 'jquery';
import template from './template';
import "./index.css"

jQuery(document).ready(() => {
    if (740 < jQuery(window).width()) {
        jQuery('#js-interactive').html(template);

        const margin = { top: 1, right: 50, bottom: 6, left: 67 };
        let width = parseInt(d3.select('#chart').style('width'));
        width = width - margin.left - margin.right;

        const ratio = 0.62;
        const height = width * ratio;

        const formatNumber = d3.format(',.0f');
        const format = d => formatNumber(d);
        const color = d3.scale.category20();

        const svg = d3
            .select('#chart')
            .append('svg')
            .attr('id', 'svg')
            .attr('width', width + margin.left + margin.right + 58)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', `translate(${margin.left + 30},${margin.top})`)
            .attr('class', 'gElement')

        const sankey = d3
            .sankey()
            .nodeWidth(10)
            .nodePadding(15)
            .size([width, height]);

        const path = sankey.link();
        // REMEMBER TO CHANGE TO A DIRECT PATH BEFORE PUSHING LIVE
        d3.json(
            '//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/dem-candidate-switching.json',
            energy => {
                sankey
                    .nodes(energy.nodes)
                    .links(energy.links)
                    .layout(32);

                const linkGroup = svg.append('g').attr('class', 'link-group');

                const link = linkGroup
                    .selectAll('.link')
                    .data(energy.links)
                    .enter()
                    .append('path')
                    .attr('d', path)
                    .attr('class', d => {
                        const groupName = d.target.group.replace(/\s/g, ''); // remove space from group (month/year) name
                        const target = d.target.name.replace(/'/g, '');
                        const source = d.source.name.replace(/'/g, '');
                        return (
                            `link ${groupName}${target} ${target}-from` +
                            ` ${source}-to`
                        );
                    })
                    .style('stroke-width', d => Math.max(1, d.dy))
                    .style('stroke', d => d.color)
                    .sort((a, b) => a.dy - b.dy)

                link.append('data-title').text(d => {
                    return `${
                        d.source.name
                        } → ${d.target.name}\n${format(d.source_pct)} ${format(d.target_pct)}`;
                });

                const node = svg
                    .append('g')
                    .selectAll('.node')
                    .data(energy.nodes)
                    .enter()
                    .append('g')
                    .attr('class', 'node')
                    .sort((a, b) => a.dy - b.dy)
                    .attr('transform', d => `translate(${d.x},${d.y})`)

                node.append('rect')
                    .attr('height', d => d.dy)
                    .attr('width', '10px')
                    .style('fill', '#ffffff')
                    .style('stroke', '#000000')
                    .style('margin-bottom', '5px')
                    .append('data-title') // tooltip
                    .text(d => `${d.name} ${d.group.replace(/\s/g, '')}`)

                node.append('text') // Node names
                    .attr('x', 15) // X-value placement
                    .attr('y', d => d.dy / 2)
                    .attr('dy', '.35em')
                    .attr('text-anchor', 'start')
                    .attr('transform', null)
                    .style('color', '#BBBDC0')
                    .text(d => d.name)
                    .filter(d => d.x < width / 5)
                    .attr('x', -15 + sankey.nodeWidth()) // Moves labels to the left for the first time period
                    .attr('text-anchor', 'end');
            },
        );

        const clearActive = () => {
            jQuery('.active-rect').removeAttr('class'); // un-highlight active rectangles
            jQuery('g .node').removeAttr('style'); // Remove bolding from active labels
            jQuery('.link').fadeTo(400, '.2'); // fade out previously highlighted lines
            jQuery('.link').removeAttr('id'); // Remove id from each line so that all lines lose their highlighting
            jQuery('.verticalLine, .dropoutText').hide(); // Hide dropout line
        };

        const hideStoryBoxes = () => {
            jQuery('.story-boxes').css('visibility', 'hidden');
        };

        const clintonTooltips = () => {
            // Custom tooltips for clinton. Must be called at the end of each step in the clinton story
            const direction = jQuery('#direction-drop option:selected').val();

            if ('wentTo' === direction) {
                const active = svg.selectAll('#clinton-to').call(
                    d3.helper
                        .tooltip() // format text for tooltip
                        .attr('class', (d, i) => `${d} ${i} A`)
                        .attr('d', 'b')
                        .text((d, i) => {
                            const source = d.source.name;
                            const sourceImg = source.replace(/'/g, '');
                            const target = d.target.name;
                            const targetImg = target.replace(/'/g, '');
                            const { source_pct } = d;
                            const { target_pct } = d;
                            const sourceGroup = d.source.group;
                            const targetGroup = d.target.group;
                            const images = `<div class='img-wrapper'><img src='//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/${sourceImg}.png'><img src='//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/arrow.png'><img src='//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/${targetImg}.png'></div>`;

                            return `${images}<p><span>${source_pct}%</span> of ${source} supporters in ${sourceGroup} supported ${target} in ${targetGroup}</p>`;
                        }));
            } else if ('cameFrom' === direction) {
                const active = svg.selectAll('#clinton-to').call(
                    d3.helper
                        .tooltip() // format text for tooltip
                        .attr('class', (d, i) => `${d} ${i} A`)
                        .attr('d', 'b')
                        .text((d, i) => {
                            let source = d.source.name;
                            const sourceImg = source.replace(/'/g, '');
                            const target = d.target.name;
                            const targetImg = target.replace(/'/g, '');
                            const { source_pct } = d;
                            const { target_pct } = d;
                            const sourceGroup = d.source.group;
                            const targetGroup = d.target.group;
                            const images = `<div class='img-wrapper'><img src='//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/${sourceImg}.png'><img src='//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/arrow.png'><img src='//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/${targetImg}.png'></div>`;
                            let supp = '';

                            if ('Undecided' === source) {
                                supp = 'voters';
                                // var source = 'undecided';
                                source = 'undecided';
                            } else {
                                supp = 'supporters';
                            }

                            if ('Undecided' === source || 'undecided' === source) {
                                // If the source is undecided
                                return `${images}<p><span>${target_pct}%</span> of ${target} ${supp} in ${targetGroup} were undecided in ${sourceGroup}</p>`;
                            }
                            if ('Other' === source) {
                                return `${images}<p><span>${target_pct}%</span> of ${target} supporters in ${targetGroup} supported some other candidate in ${sourceGroup}</p>`;
                            }
                            return `${images}<p><span>${target_pct}%</span> of ${target} supporters in ${targetGroup} supported ${source} in ${sourceGroup}</p>`;
                        }));
            }
        };

        const startClintonPath = () => {
            hideStoryBoxes();
            clearActive();
            jQuery('#all-democrats-dropdown').css('visibility', 'hidden'); // Hide dropdown menus
            jQuery('#direction-drop option:eq(0)').prop('selected', true); // Re-select "cameFrom" in case it was changed
            jQuery('g .node text:contains(Clinton)')
                .parent()
                .css('font-weight', 'bold')
                .fadeTo('slow', '1'); // Bold the clinton labels
            jQuery('#clinton-path').addClass('active-button');
            jQuery('.time-blurb').css('visibility', 'hidden');
            jQuery('#Aug15-div').css('visibility', 'visible'); // Show the first story box
            jQuery('#Mar-blurb')
                .css('visibility', 'visible')
                .html(
                    '<p><span>41%</span> of Democratic voters named Clinton their first choice in March 2015.</p>',
                ); // Show first blurb
            jQuery('.time-label:nth-of-type(3)').css('font-weight', 'bold'); // Bold the 'March 2015' label
            d3.selectAll('g.link-group path') // Disable tooltips for all non-active lines
                .on('mouseover', null)
                .on('mousemove', null)
                .on('mouseout', null);
        };

        const Aug15 = () => {
            jQuery('.link.August2015Clinton')
                .attr('id', 'clinton-to')
                .fadeTo('slow', '1'); // Highlight the first section's lines
            hideStoryBoxes(); // Hide the first story box
            jQuery('#Dec15-div').css('visibility', 'visible'); // Show the next story box
            jQuery('#Aug-blurb')
                .css('visibility', 'visible')
                .html(
                    '<p><span>38%</span> of Democratic voters named Clinton their first choice in August 2015.</p>',
                ); // Show first blurb
            jQuery('.time-label:nth-of-type(4)').css('font-weight', 'bold'); // Bold "August 2015"
            jQuery(
                'rect > data-title:contains("Clinton March2015"), rect > data-title:contains("Clinton August2015")',
            )
                .parent()
                .attr('class', 'active-rect'); // highlight new active rectangles
            clintonTooltips();
        };

        const Dec15 = () => {
            jQuery('.link.December2015Clinton')
                .attr('id', 'clinton-to')
                .fadeTo('slow', '1'); // Highlight section lines
            hideStoryBoxes(); // Hide previous story box
            jQuery('#Apr16-div').css('visibility', 'visible'); // Show the next story box
            jQuery('#Dec-blurb')
                .css('visibility', 'visible')
                .html(
                    '<p><span>48%</span> of Democratic voters named Clinton their first choice in December 2015.</p>',
                ); // Show first blurb
            jQuery('.time-label:nth-of-type(5)').css('font-weight', 'bold'); // Bold "December 2015"
            jQuery('rect > data-title:contains("Clinton December2015")')
                .parent()
                .attr('class', 'active-rect'); // highlight new active rectangles
            clintonTooltips();
        };

        const Apr16 = () => {
            jQuery('.link.April2016Clinton')
                .attr('id', 'clinton-to')
                .fadeTo('slow', '1'); // Highlight section lines
            hideStoryBoxes(); // Hide previous story box
            jQuery('#June16-div').css('visibility', 'visible'); // Show the next story box
            jQuery('#April-blurb')
                .css('visibility', 'visible')
                .html(
                    '<p><span>46%</span> of Democratic voters named Clinton their first choice in April 2016.</p>',
                ); // Show first blurb
            jQuery('.time-label:nth-of-type(6)').css('font-weight', 'bold'); // Bold "April 2016"
            jQuery('rect > data-title:contains("Clinton April2016")')
                .parent()
                .attr('class', 'active-rect'); // highlight new active rectangles
            clintonTooltips();
        };

        const June16 = () => {
            jQuery('.link.June2016Clinton')
                .attr('id', 'clinton-to')
                .fadeTo('slow', '1'); // Highlight section lines
            hideStoryBoxes(); // Hide previous story box
            jQuery('#unity').css('visibility', 'visible'); // Show the next story box
            jQuery('#June-blurb')
                .css('visibility', 'visible')
                .html(
                    '<p><span>90%</span> of Democratic voters named Clinton their first choice in the general election.</p>',
                ); // Show first blurb
            jQuery('.time-label:nth-of-type(7)').css('font-weight', 'bold'); // Bold "June 2016"
            jQuery('rect > data-title:contains("Clinton June2016")')
                .parent()
                .attr('class', 'active-rect'); // highlight new active rectangles
            clintonTooltips();
        };

        jQuery('button').click(() => {
            // Add active classing to active buttons and hide all story boxes
            jQuery('button').removeClass('active-button');
            jQuery(this).addClass('active-button');
            hideStoryBoxes();
        });

        const changeCandidate = () => {
            const candidateDrop = jQuery('#candidate-drop option:selected');
            const candidate = candidateDrop.text(); // Candidate selected from dropdown
            const candidateReplace = candidate.replace(/'/g, '');
            const idNameTo = `${candidate.toLowerCase().replace(/'/g, '')}-to`; // candidate in lowercase
            const direction = jQuery('#direction-drop option:selected').val(); // which direction is selected in the dropdown
            const dropout = candidateDrop.attr('value2'); // position for candidate dropout line
            const Mar = candidateDrop.attr('Mar');
            const Aug = candidateDrop.attr('Aug');
            const Dec = candidateDrop.attr('Dec');
            const Apr = candidateDrop.attr('Apr');
            const Gen = candidateDrop.attr('Gen');

            clearActive();

            jQuery(`rect > data-title:contains(${candidate})`)
                .parent()
                .attr('class', 'active-rect'); // highlight new active rectangles
            jQuery(`g .node text:contains(${candidate})`)
                .parent()
                .css('font-weight', 'bold')
                .fadeTo('slow', '1'); // Bold the selected candidate labels
            jQuery('#Mar-blurb').html(
                `<p><span>${Mar}%</span> of Democratic voters named ${candidate} their first choice in March 2015.</p>`,
            );
            jQuery('#Aug-blurb').html(
                `<p><span>${Aug}%</span> of Democratic voters named ${candidate} their first choice in August 2015.</p>`,
            );
            jQuery('#Dec-blurb').html(
                `<p><span>${Dec}%</span> of Democratic voters named ${candidate} their first choice in December 2015.</p>`,
            );
            jQuery('#April-blurb').html(
                `<p><span>${Apr}%</span> of Democratic voters named ${candidate} their first choice in April 2016.</p>`,
            );
            jQuery('.time-blurb').css('visibility', 'visible');

            if ('Other' === candidate || 'Undecided' === candidate || '' === Gen) {
                jQuery('#June-blurb').css('visibility', 'hidden');
            } else {
                jQuery('#June-blurb').html(
                    `<p><span>${Gen}%</span> of Democratic voters named ${candidate} their first choice in the general election.</p>`,
                );
            }

            d3.selectAll('g.link-group path') // Disable tooltips for all non-active lines
                .on('mouseover', null)
                .on('mousemove', null)
                .on('mouseout', null);

            if ('wentTo' === direction) {
                jQuery(`.${candidateReplace}-to`).attr('id', idNameTo); // Find lines with the went-to class, give them a unique id
                jQuery(`[class*="${candidateReplace}-to"]`).fadeTo(400, '1'); // fade in newly active lines
                if (dropout === undefined) {
                    // if candidate has no dropout date, hide line
                    jQuery('.verticalLine, .dropoutText').hide();
                } else {
                    // if candidate has a dropout date, show the line and text and switch candidate name
                    jQuery('.dropoutText span').html(candidate);
                    jQuery('.verticalLine, .dropoutText')
                        .css('left', `${dropout}%`)
                        .show();
                }
                const active = svg
                    .selectAll(`#${idNameTo}`) // Select active candidate/directional lines for tooltip
                    .style('z-index', '1000')
                    .call(
                        d3.helper
                            .tooltip() // format text for tooltip
                            .attr('class', (d, i) => `${d} ${i} A`)
                            .attr('d', 'b')
                            .text((d, i) => {
                                // Tooltip queries
                                let source = d.source.name;
                                const sourceImg = source.replace(/'/g, '');
                                const target = d.target.name;
                                const targetImg = target.replace(/'/g, '');
                                const { source_pct } = d;
                                const { target_pct } = d;
                                const sourceGroup = d.source.group;
                                const targetGroup = d.target.group;
                                const images = `<div class='img-wrapper'><img src='//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/${sourceImg}.png'><img src='//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/arrow.png'><img src='//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/${targetImg}.png'></div>`;
                                let supp = ''

                                if ('Undecided' === source) {
                                    supp = 'voters';
                                    // var source = 'undecided';
                                    source = 'undecided';
                                } else {
                                    supp = 'supporters';
                                }

                                if ('9999' === source_pct || '' === source_pct) {
                                    // If percentage is undefined
                                    if ('Other' === source) {
                                        return `<div class='img-wrapper'><img src='//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/Other.png'></div><p>There were too few supporters of other candidates in ${sourceGroup} to reliably estimate this proportion.</p>`;
                                    }
                                    return `<div class='img-wrapper'><img src='//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/${sourceImg}.png'></div><p>There were too few ${source} ${supp} in ${sourceGroup} to reliably estimate this proportion.</p>`;
                                }
                                if (
                                    'Undecided' === source &&
                                    'Undecided' === target
                                ) {
                                    // If the source and target are both undecided
                                    return `${images}<p><span>${source_pct}%</span> of undecided voters in ${sourceGroup} were also undecided in ${targetGroup}</p>`;
                                }
                                if ('Undecided' === target) {
                                    // If the target is undecided
                                    return `${images}<p><span>${source_pct}%</span> of ${source} ${supp} in ${sourceGroup} were undecided in ${targetGroup}</p>`;
                                }
                                if ('Other' === source) {
                                    return `${images}<p><span>${source_pct}%</span> of voters who supported some other candidate in ${sourceGroup} supported ${target} in ${targetGroup}</p>`;
                                }
                                if ('Other' === target) {
                                    return `${images}<p><span>${source_pct}%</span> of ${source} ${supp} in ${sourceGroup} supported some other candidate in ${targetGroup}</p>`;
                                } // Deafult tooltip
                                return `${images}<p><span>${source_pct}%</span> of ${source} ${supp} in ${sourceGroup} supported ${target} in ${targetGroup}</p>`;
                            }),
                    );
            } else if ('cameFrom' === direction) {
                jQuery(`.${candidateReplace}-from`).attr('id', idNameTo); // Find lines with the came-from class, give them a unique id
                jQuery(`[class*="${candidateReplace}-from"]`).fadeTo(400, '1'); // fade in newly active lines
                if (dropout === undefined) {
                    // if candidate has no dropout date, hide line
                    jQuery('.verticalLine, .dropoutText').hide();
                } else {
                    // if candidate has a dropout date, show the line and text and switch candidate name
                    jQuery('.dropoutText span').html(candidate);
                    jQuery('.verticalLine, .dropoutText')
                        .css('left', `${dropout}%`)
                        .show();
                }
                const active = svg
                    .selectAll(`#${idNameTo}`)
                    .style('z-index', '1000')
                    .call(
                        d3.helper
                            .tooltip() // format text for tooltip
                            .attr('class', (d, i) => `${d} ${i} A`)
                            .attr('d', 'b')
                            .text((d, i) => {
                                // Tooltip queries
                                const source = d.source.name;
                                const sourceImg = source.replace(/'/g, '');
                                let target = d.target.name;
                                const targetImg = target.replace(/'/g, '');
                                const { source_pct } = d;
                                const { target_pct } = d;
                                const sourceGroup = d.source.group;
                                const targetGroup = d.target.group;
                                const images = `<div class='img-wrapper'><img src='//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/${sourceImg}.png'><img src='//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/arrow.png'><img src='//assets.pewresearch.org/interactives/politics/2016/dem-candidate-switching/${targetImg}.png'></div>`;
                                let supp = ''
                                if ('Undecided' === target) {
                                    supp = 'voters';
                                    // var target = 'undecided';
                                    target = 'undecided';
                                } else {
                                    supp = 'supporters';
                                }

                                if ('9999' === target_pct) {
                                    // If percentage is undefined
                                    if ('Other' === target) {
                                        return `${images}<p>There were too few supporters of other candidates in ${targetGroup} to reliably estimate this proportion.</p>`;
                                    }
                                    return `${images}<p>There were too few ${target} ${supp} in ${targetGroup} to reliably estimate this proportion.</p>`;
                                }
                                if (
                                    'Undecided' === source &&
                                    'Undecided' === target
                                ) {
                                    // If the source and target are both undecided
                                    return `${images}<p><span>${target_pct}%</span> of undecided voters in ${targetGroup} were also undecided in ${sourceGroup}</p>`;
                                }
                                if ('Undecided' === source) {
                                    // If the source is undecided
                                    return `${images}<p><span>${target_pct}%</span> of ${target} ${supp} in ${targetGroup} were undecided in ${sourceGroup}</p>`;
                                }
                                if ('Other' === source) {
                                    return `${images}<p><span>${target_pct}%</span> of ${target} supporters in ${targetGroup} supported some other candidate in ${sourceGroup}</p>`;
                                }
                                if ('Other' === target) {
                                    return `${images}<p><span>${target_pct}%</span> of ${source} ${supp} in ${sourceGroup} supported some other candidate in ${targetGroup}</p>`;
                                } // Default tooltip
                                return `${images}<p><span>${target_pct}%</span> of ${target} ${supp} in ${targetGroup} supported ${source} in ${sourceGroup}</p>`;
                            }));
            }
        };

        jQuery('#all-democrats, #unity-button').click(() => {
            changeCandidate();
            jQuery('#all-democrats-dropdown').css('visibility', 'visible'); // Show dropdown boxes
            jQuery('.story-boxes, #unity').css('visibility', 'hidden'); // Hide all story boxes
            jQuery('#all-democrats').addClass('active-button'); // Add active class to newly active button
            jQuery('#candidate-drop option:eq(10)').prop('selected', true); // Re-select "clinton" in case it was changed
        });

        jQuery('.clinton-link').click(() => {
            // Remove active classing any time a clinton story link is clicked
            jQuery('.time-label').removeAttr('style'); // Remove bolding from all time labels
        });

        jQuery('#clinton-path, #Dec15-link-prev').click(startClintonPath);

        jQuery('#Aug15-link, #Apr16-link-prev').click(Aug15);

        jQuery('#Dec15-link, #June16-link-prev').click(Dec15);

        jQuery('#Apr16-link').click(Apr16);

        jQuery('#June16-link').click(June16);

        jQuery('#Dec15-link-prev').click(() => {
            jQuery('#Aug-blurb').css('visibility', 'hidden');
        });

        jQuery('#Apr16-link-prev').click(() => {
            jQuery('.link.December2015Clinton')
                .removeAttr('id')
                .fadeTo('slow', '.2'); // Unselect previous lines when clicking back link
            jQuery('#Dec-blurb').css('visibility', 'hidden');
        });

        jQuery('#June16-link-prev').click(() => {
            jQuery('.link.April2015Clinton')
                .removeAttr('id')
                .fadeTo('slow', '.2'); // Unselect previous lines when clicking back link
            jQuery('#April-blurb').css('visibility', 'hidden');
        });

        jQuery('select').change(changeCandidate);

        const chartHeight = jQuery('#chart').height();
        jQuery('.verticalLine').css('height', `${chartHeight}px`);

        // Tooltip helper via https://gist.github.com/milroc/2975255
        d3.helper = {};
        d3.helper.tooltip = function () {
            let tooltipDiv;
            const bodyNode = d3.select('body').node();
            const attrs = [];
            let text = '';
            const styles = [];

            function tooltip(selection) {
                selection
                    .on('mouseover', function (d, i) {
                        // d3.select(this.parentNode.appendChild(this)).transition().duration(100)
                        //     .style({'stroke-opacity':1,'stroke':'#808284', 'stroke-width':'1'});
                        let name;
                        let value;
                        // Clean up lost tooltips
                        d3.select('body')
                            .selectAll('div.tooltip')
                            .remove();
                        // Append tooltip
                        tooltipDiv = d3.select('body').append('div');
                        for (const i in attrs) {
                            // var name = attrs[i][0];
                            name = attrs[i][0];
                            if ('function' === typeof attrs[i][1]) {
                                value = attrs[i][1](d, i);
                            } else value = attrs[i][1];
                            if ('class' === name) value += ' tooltip';
                            tooltipDiv.attr(name, value);
                        }
                        for (const i in styles) {
                            name = styles[i][0];
                            if ('function' === typeof attrs[i][1]) {
                                value = styles[i][1](d, i);
                            } else value = styles[i][1];
                            tooltipDiv.style(name, value);
                        }
                        const absoluteMousePos = d3.mouse(bodyNode);
                        tooltipDiv
                            .style('left', `${absoluteMousePos[0] + 10}px`)
                            .style('top', `${absoluteMousePos[1] - 15}px`)
                            .style('position', 'absolute')
                            .style('z-index', 1001);
                        // Add text using the accessor function
                        let tooltipText = '';
                        if ('function' === typeof text) tooltipText = text(d, i);
                        else if ('undefined' !== typeof text || null != typeof text)
                            tooltipText = text;
                        // Crop text arbitrarily
                        tooltipDiv
                            .style('width', function (d, i) {
                                return 80 < tooltipText.length ? '200px' : null;
                            })
                            .html(tooltipText);
                    })
                    .on('mousemove', function (d, i) {
                        // Move tooltip
                        const absoluteMousePos = d3.mouse(bodyNode);
                        tooltipDiv
                            .style('left', `${absoluteMousePos[0] + 10}px`)
                            .style('top', `${absoluteMousePos[1] - 15}px`);
                        let tooltipText = '';
                        if ('string' === typeof text) tooltipText = text;
                        if ('function' === typeof text) tooltipText = text(d, i);
                        tooltipDiv.html(tooltipText);
                    })
                    .on('mouseout', function (d, i) {
                        // d3.select(this.parentNode.appendChild(this)).transition().duration(100)
                        //     .style({'stroke-opacity':1,'stroke':'#d7d7d7', 'stroke-width':'1'});
                        // Remove tooltip
                        tooltipDiv.remove();
                    });
            }

            tooltip.attr = function (name, value) {
                attrs.push(arguments);
                return this;
            };

            tooltip.text = function (value) {
                text = value;
                return this;
            };

            tooltip.style = function (name, value) {
                styles.push(arguments);
                return this;
            };

            return tooltip;
        };
        jQuery(window).load(() => {
            // After EVERYTHING loads, including images.
            startClintonPath();
        });

        jQuery('#static_mobile').hide();
    } else {
        // Add your javascript for small screens here
        jQuery('#interactive').hide();
        jQuery('#static_mobile').show();
    }
})
